document.addEventListener("DOMContentLoaded", function () {
  // announcement bar slider :STARTS
  var mySwiper1 = null;
  function initSwiper1() {
    if (window.innerWidth <= 1024) {
      if (!mySwiper1) {
        mySwiper1 = new Swiper(".yar_announcement_slider", {
          spaceBetween: 12,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
        });
      }
    } else {
      if (mySwiper1) {
        mySwiper1.destroy();
        mySwiper1 = null;
      }
    }
  }
  window.addEventListener("load", initSwiper1);
  window.addEventListener("resize", initSwiper1);
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      if (mySwiper1) {
        mySwiper1.destroy();
        mySwiper1 = null;
      }
      initSwiper1();
    });
  }
  // announcement bar slider :ENDS
  // upsell slider :STARTS

  // upsell slider :ENDS
  class UpsellSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderRef = this.querySelector("[data-slider]");
      this.nextRef = this.querySelector('[data-navigation="next"]') || null;
      this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
      this.paginationRef = this.querySelector("[data-pagination]") || null;
      this.initSlider = this.initSlider.bind(this);
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.swiper = new Swiper(this.sliderRef, {
        // Optional parameters
        loop: true,
        spaceBetween: 20,
        autoplay: false,
        rewind: false,
        slidesPerView: 1.2,
        freeMode: true,
        pagination: {
          el: this.paginationRef,
        },
        navigation: {
          nextEl: this.nextRef,
          prevEl: this.previousRef,
        },
        breakpoints: {
          468: {
            slidesPerView: 1.2,
          },
          800: {
            spaceBetween: 25,
            slidesPerView: 2.12,
          }
        },
      });
    }

    disconnectedCallback() {
      this.swiper.destroy();
    }
  }

  customElements.define("upsell-slider", UpsellSlider);
});
